import * as React from 'react';
import { ActivityDestinationViewSearch } from '../../../../common/__generated__/api';
import { PlaceholderCards } from '../../../../components/srp/modules/module-components';
import { ActivityMessageBanner } from '../../../../components/common/banners/activity-message-banner';
import { mapMessageTileToBannerProps } from '../../../common/banners/activity-message-banner-helper';
import { ActivitySpannedTileCard } from '../../../../components/srp/modules/module-components/simple-result-card';

export interface ListLayoutResultsCardProps {
  activityTiles: ActivityDestinationViewSearch.ActivityTiles[];
  loading: boolean;
  onClick: (activity: ActivityDestinationViewSearch.ActivityInlineFragment, index: number) => void;
}

export const ListLayoutComponent: React.FC<ListLayoutResultsCardProps> = ({
  activityTiles,
  loading,
  onClick
}): JSX.Element => {
  let activityTileIndex = -1;

  if (loading) {
    return <PlaceholderCards />;
  }

  const getListViewTile = (
    activityTile: ActivityDestinationViewSearch.ActivityTiles,
    index: number
  ): JSX.Element | null => {
    switch (activityTile.__typename) {
      case 'Activity':
        activityTileIndex += 1;

        return (
          <ActivitySpannedTileCard
            key={`acitivity-spanned-tile-card-${activityTile.id}`}
            activity={activityTile}
            loading={false}
            index={activityTileIndex}
            isRecommendationTile={false}
            onClick={onClick}
            className="uitk-card-separator-bottom"
            titleLines={3}
          />
        );
      case 'ActivityMessageTile':
        return (
          <ActivityMessageBanner
            {...mapMessageTileToBannerProps(
              activityTile as ActivityDestinationViewSearch.ActivityMessageTileInlineFragment
            )}
            key={`acitivity-message-card-${index}`}
            className="all-y-margin-six full-width"
          />
        );
      default:
        return null;
    }
  };

  const renderListViewActivityCard = (): JSX.Element => (
    <>{activityTiles && activityTiles.map((activityTile, index) => getListViewTile(activityTile, index))}</>
  );

  return renderListViewActivityCard();
};
